import { useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/lib/contexts/AuthContext'

export default function Home() {
  const { token, isLoading } = useAuth()
  const location = useLocation()

  useEffect(() => {
    document.title = 'Humblytics - Analytics & Conversion Intelligence';
  }, []);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-lg">Loading...</div>
      </div>
    )
  }

  if (token) {
    return <Navigate to={`/dashboard${location.search}`} replace />
  }

  return <Navigate to="/auth?mode=signup" replace />
}






